import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const Group = styled.g``;

export interface Props {
  data: ISimejiItem;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Eyes({ data }: Props) {
  const {
    eyeHighlightLineColor,
    leftEyeLineColor,
    rightEyeLineColor,
    underlashColor,
    irisColor,
    leftEyeColor,
    rightEyeColor,
    eyesWidth,
    irisWidth,
    eyeHighlight,
  } = data;

  return (
    <>
      <g className="eyebrow">{/* left */}</g>
      <Group className="eyes">
        {/* 왼눈 */}
        <g className="left-eye">
          <path
            className="underlash"
            d="M37.5 78C36.3333 78.5 34.5 79.2 32.5 78"
            stroke={underlashColor}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle
            cx="7"
            cy="7"
            r={eyesWidth || 6.5}
            transform="matrix(-1 0 0 1 42 63)"
            fill={leftEyeColor}
            stroke={leftEyeLineColor}
          />
          <circle
            cx="3.5"
            cy="3.5"
            r={irisWidth || 3.5}
            transform="matrix(-1 0 0 1 39 65)"
            fill={irisColor}
          />
          <circle
            cx="2"
            cy="2"
            r="1.75"
            transform="matrix(-1 0 0 1 37 70)"
            fill="white"
            stroke={eyeHighlightLineColor}
            strokeWidth="0.5"
          />
        </g>

        {/* 오른눈 */}
        <g className="right-eye">
          <path
            className="underlash"
            d="M62.5 78C63.6667 78.5 65.5 79.2 67.5 78"
            stroke={underlashColor}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle
            cx="65"
            cy="70"
            r={eyesWidth || 6.5}
            fill={rightEyeColor}
            stroke={rightEyeLineColor}
          />
          <circle cx="64.5" cy="68.5" r={irisWidth || 3.5} fill={irisColor} />
          <circle
            // cx={eyeHighlight ? eyeHighlight[0].x + 60 : 65}
            // cy={eyeHighlight ? eyeHighlight[0].y + 60 : 72}
            cx="65"
            cy="72"
            r="1.75"
            fill="white"
            stroke={eyeHighlightLineColor}
            strokeWidth="0.5"
          />
        </g>
      </Group>
    </>
  );
}

export default React.memo(Eyes);
